<template>
  <div class="data_brain_wrap">
    <el-row class="card_wrap" type="flex">
      <el-col class="brain_item" :lg="11" :sm="24">
        <div class="box_top map_top_box">
<!--          有远见 选璟点-->
          <img src="../../../assets/img/home/map/map_top.png" alt="" />
        </div>
        <div class="item_desc">
          <p>璟点台球集团创立于2009年，是一家总部位于中国辽宁东戴河的台球全产业链企业，产业园面积超12万平米。</p>
          <p>集团拥有包括美洲豹、环球、达芬尼在内的多个国际知名品牌中国区总代理权，并构建了集研发制造、赛事运营与渠道销售于一体的综合业务体系。</p>
          <p>璟点台球集团始终致力推动产业升级，矢志打造具有全球影响力的台球产业龙头企业。</p>
        </div>

        <div class="item_en box">
          Provide customers with<br/>
          public relations affairs solutions.
        </div>
        <div class="box map_left_box">
          <img src="../../../assets/img/home/map/map_down.png" alt="" />
        </div>
      </el-col>

      <el-col class="brain_item_map" :lg="12"  :sm="24">
        <img src="../../../assets/img/home/map/map.png" alt="全国璟点台球桌分布地图" style="width: 100%; height: auto;padding-top: 80px" />
        <div class="map_label_red">
          <p>目标<span>3</span>年<span>100</span>家</p>
          <p>直营店落地</p>
<!--          <p>俱乐部<span>超万</span>家</p>-->
        </div>

        <div class="map_label_blue">
          <p>截止今天</p>
          <p>全国璟点器材授权</p>
          <p>门店<span>超200</span>家</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding-bottom: 80px;
  text-align: center;

  // 仅保留移动端全局内边距调整
  @media screen and (max-width: 767px) {
    padding-bottom: 40px;
  }

  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    // 仅移动端调整标题大小
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    // 仅移动端调整描述文字
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }

  .card_wrap {
    width: 100%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;

    // 仅移动端调整容器宽度
    @media screen and (max-width: 768px) {
      width: 95%;
    }

    .brain_item_map {
      transition: background-color 1s;
      padding: 0 50px 0 30px;
      position: relative;

      // 仅移动端调整地图容器样式
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        &:nth-child(-n+2){
          margin-top: 0;
        }
        padding: 0 10px;
      }

      .item_navigate {
        width: 190px;
        height: 50px;
        background: #033885;
        color: #fff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-left: 540px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        justify-content: space-between;

        // 仅移动端调整按钮样式
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          width: 70px;
          height: 20px;
          margin-left: 200px;
          font-size: 6px;
        }
      }

      // 红色标签 - 仅保留PC样式+移动端适配
      .map_label_red {
        width: 250px;
        height: 200px;
        font-size: 16px;
        text-align: left;
        background: url('../../../assets/img/home/map/mapbg2.png') no-repeat;
        background-size: 100%;
        position: absolute;
        top: 570px;
        left: 185px;
        padding: 30px 30px;
        z-index: 2;
        @media screen and (min-width: 769px) and (max-width: 1200px) {
          top:90%;
          left: 45%;
        }

        // 仅移动端调整红色标签
        @media screen and (max-width: 768px) {
          width: 110px;
          height: 80px;
          top:205px;
          left: 80px;
          padding: 10px 10px;
          background-size: 100% 100%;
          p {
            line-height: 1.5;
            padding-top: 5px;
            font-size: 10px;
          }
          span {
            color: red;
            font-weight: 600;
            font-size: 16px;
          }
        }

        // PC端基础样式（平板/PC共用）
        p {
          line-height: 1.5;
          padding-top: 5px;
          margin: 0;
        }
        span {
          color: red;
          font-weight: 600;
          font-size: 24px;
        }
      }

      // 蓝色标签 - 仅保留PC样式+移动端适配
      .map_label_blue {
        width: 250px;
        height: 200px;
        font-size: 16px;
        text-align: left;
        background: url('../../../assets/img/home/map/mapbg1.png') no-repeat;
        background-size: 100%;
        position: absolute;
        top:125px;
        left: 530px;
        padding: 30px 30px;
        z-index: 2;
        @media screen and (min-width: 769px) and (max-width: 1200px) {
          top:10%;
          left: 75%;
        }

        // 仅移动端调整蓝色标签
        @media screen and (max-width: 768px) {
          width: 110px;
          height: 80px;
          top:50px;
          left: 230px;
          padding: 10px 10px;
          background-size: 100% 100%;
          p {
            line-height: 1.5;
            padding-top: 5px;
            font-size: 10px;
          }
          span {
            color: #033885;
            font-weight: 600;
            font-size: 16px;
          }
        }

        // PC端基础样式（平板/PC共用）
        p {
          line-height: 1.5;
          padding-top: 5px;
          margin: 0;
        }
        span {
          color: #033885;
          font-weight: 600;
          font-size: 24px;
        }
      }
    }

    .brain_item {
      transition: background-color 1s;
      padding: 0 0 0 140px;
      position: relative;

      // 仅移动端调整文本容器样式
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        &:nth-child(-n+2){
          margin-top: 30px;
        }
        padding: 0 10px;
      }

      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg{
        opacity: 1;
      }

      .item_title {
        transition: all 0.5s;
        font-size: 40px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 60px 0;
        z-index: 2;
        position: inherit;
        letter-spacing: 5px;

        // 仅移动端调整标题
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
          padding-bottom: 30px;
        }
      }

      .item_desc {
        transition: all 0.5s;
        color: #203040;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 23px;
        min-height: 110px;
        letter-spacing: 3px;
        font-weight: 500;

        // 仅移动端调整描述容器
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          font-size: 12px;
          letter-spacing: 1px;
        }

        p {
          line-height: 1.5;
          padding-bottom: 20px;
          margin: 0;

          // 仅移动端调整段落间距
          @media screen and (max-width: 768px) {
            padding-bottom: 10px;
          }
        }
      }
    }
  }

  .red_span {
    color: red;
  }

  .item_en{
    font-size: 20px;
    text-align: left;
    padding-top: 65px;

    // 仅移动端调整英文文本
    @media screen and (max-width: 768px) {
      font-size: 8px;
      padding-top: 15px;
      line-height: 10PX;
    }
  }

  .box {
    float: left;
    width: 50%;
  }
  .box_top {
    width: 50%;
  }

  .map_top_box {
    width: 230px;
    padding: 80px 0 50px 0;
    //border-bottom: 2px solid #c2c2c2;
    img{
      width: 300px;
      @media screen and (max-width: 768px) {
        width: 120px;
      }
      //height: 45px;
    }


  }

  .map_left_box {
    width: 230px;
    padding-top: 15px;
    margin-left: 135px;
    //border-bottom: 2px solid #c2c2c2;

    // 仅移动端调整左侧图片容器
    @media screen and (max-width: 768px) {
      border-bottom: none;
      margin-top: -15px;
    }

    img{
      width: 230px;
      @media screen and (max-width: 768px) {
        width: 120px;
      }
    }
  }

  .project_pic {
    height: 200px;
  }
}

#mainMap {
  position: relative;
  z-index: 1;
}
</style>